<template>
  <div class="back-home-content">
    <div class="action" @click="backHome">
      返回首页
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.back-home-content {
  .action {
    width: 360px;
    height: 80px;
    border-radius: 40px;
    border: 2px solid #FF4633;
    margin-top: 40px;
    font-size: 32px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FF4633;
    line-height: 80px;
    text-align: center;
    margin: 0 auto;
  }
}
</style>